/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiOrcaDataRfqPost } from '../fn/orca-data/api-orca-data-rfq-post';
import { ApiOrcaDataRfqPost$Params } from '../fn/orca-data/api-orca-data-rfq-post';

@Injectable({ providedIn: 'root' })
export class OrcaDataService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiOrcaDataRfqPost()` */
  static readonly ApiOrcaDataRfqPostPath = '/api/orca-data/Rfq';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOrcaDataRfqPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiOrcaDataRfqPost$Response(params?: ApiOrcaDataRfqPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiOrcaDataRfqPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiOrcaDataRfqPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiOrcaDataRfqPost(params?: ApiOrcaDataRfqPost$Params, context?: HttpContext): Observable<void> {
    return this.apiOrcaDataRfqPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
